// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6291b86a","239":"e39fb35b","455":"1b991356","578":"7cbdbbd7","857":"fcc5f8d4","977":"4b3215a8"}[chunkId] + ".chunk.js";
};